module.exports = __webpack_public_path__ + "media/audio7.f5bf67dd.mp4";